import { useState } from "react";
import { useBookingsStore } from "../../context/useBookingsStore";

export default function BookingCheckoutModal({
  booking,
  onClose,
  onDone,
}) {
  const { checkoutBooking } = useBookingsStore();

  const [manual, setManual] = useState({
    startOdometer: "",
    startFuelLevel: "",
    startCondition: "good",
  });

  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  async function submit() {
    setError(null);

    if (!manual.startOdometer) {
      setError("Start odometer is required");
      return;
    }

    try {
      setSubmitting(true);
      await checkoutBooking(booking.id, {
        ...manual,
        startOdometer: Number(manual.startOdometer),
        startFuelLevel:
          manual.startFuelLevel !== ""
            ? Number(manual.startFuelLevel)
            : undefined,
      });
      onDone();
    } catch (e) {
      setError(e.message || "Failed to check out vehicle");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="modal">
      <h3 className="text-lg font-semibold mb-2">
        Issue Keys
      </h3>

      {error && (
        <div className="text-red-600 text-sm mb-2">
          {error}
        </div>
      )}

      <input
        placeholder="Start odometer"
        type="number"
        value={manual.startOdometer}
        onChange={(e) =>
          setManual({
            ...manual,
            startOdometer: e.target.value,
          })
        }
      />

      <input
        placeholder="Fuel level (%)"
        type="number"
        value={manual.startFuelLevel}
        onChange={(e) =>
          setManual({
            ...manual,
            startFuelLevel: e.target.value,
          })
        }
      />

      <select
        value={manual.startCondition}
        onChange={(e) =>
          setManual({
            ...manual,
            startCondition: e.target.value,
          })
        }
      >
        <option value="excellent">excellent</option>
        <option value="good">good</option>
        <option value="fair">fair</option>
        <option value="poor">poor</option>
      </select>

      <div className="mt-3 flex gap-2">
        <button onClick={submit} disabled={submitting}>
          {submitting ? "Saving..." : "Confirm"}
        </button>
        <button className="secondary" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>
  );
}
